import { validateUiDate, isInThePast, isMaxYearsFromNow } from 'utils';

export const ALPHA_CHARACTERS_ONLY =
  /^[a-zA-Z- 'ßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝŸ&‘’–]+$/;
export const SPACES_ONLY = /^\s*\S.*$/;
export const NUMBERS_ONLY = /^\d+$/;
export const POSTCODE =
  /^(([A-Z]{1,2}[0-9][A-Z0-9]?|ASCN|STHL|TDCU|BBND|[BFS]IQQ|PCRN|TKCA) ?[0-9][A-Z]{2}|BFPO ?[0-9]{1,4}|(KY[0-9]|MSR|VG|AI)[ -]?[0-9]{4}|[A-Z]{2} ?[0-9]{2}|GE ?CX|GIR ?0A{2}|SAN ?TA1)$/i;

export const onKeyDownNumericInputOnly = (evt: React.KeyboardEvent<HTMLInputElement>) => {
  if (
    evt.getModifierState('Meta') ||
    evt.getModifierState('Control') ||
    evt.getModifierState('Alt')
  ) {
    return;
  }

  if (evt.key.length !== 1 || evt.key === '\x00') {
    return;
  }

  if (!new RegExp('\\d').test(evt.key)) {
    evt.preventDefault();
  }
};


export const validateCharacterNumberWithSpace = (value: string) => {
  let reg = /^[A-Za-z0-9]+[A-Za-z0-9 ]*$/;
  return value === '' ? true : reg.test(value);
};

export const digitsOnly = (value: string) => {
  let reg = /^[0-9]+$/;
  return value === '' ? true : reg.test(value);
};

export const validateCharacter = (value: string) => {
  let reg = /^[A-Za-z]+[A-Za-z]*$/;
  return value === '' ? true : reg.test(value);
};

export const validatePostcode = (postcode: string) =>
  postcode === ''
    ? false
    : /[A-Z]{1,2}[0-9Rr][0-9A-Z]?[0-9][ABD-HJLNP-UW-Z]{2}/i.test(postcode.replace(/\s/g, ''));

export const validateEmail = (email: string) => {
  const atPos = email.indexOf('@');
  if (atPos !== -1 && email.substring(atPos + 1).indexOf('.') !== -1) {
    return true;
  }
};

export const isDateValid = (value: string | null | undefined, message: string) =>
  value ? validateUiDate(value) || message : true;
// t('invalidDate', { ns: 'validation' })

export const isMax80 = (value: string, years: number, message: string) =>
  value ? isMaxYearsFromNow(value, years) || message : true;
// t('olderThan', { ns: 'validation', years: 80 })

export const isPastDate = (value: string, message: string) =>
  value ? isInThePast(value) || message : true;
// t('inFuture', { ns: 'validation' })
